import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FooterContactUsComponent } from '../components/layout/footer/footer-contact-us/footer-contact-us.component';
import { FooterFaqComponent } from '../components/layout/footer/footer-faq/footer-faq.component';
import { FooterLanguageAccesibilityComponent } from '../components/layout/footer/footer-language-accesibility/footer-language-accesibility.component';
import { FooterWhoWeAreComponent } from '../components/layout/footer/footer-who-we-are/footer-who-we-are.component';
import { BaseService } from '@app/core/services/base-service.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { FooterPrivacyPolicyComponent } from '../components/layout/footer/footer-privacy-policy/footer-privacy-policy.component';
import { GenericContentDto } from '../model/genericContentDto';

@Injectable({
    providedIn:'root'
})
export class FooterService extends BaseService{

    //#region Constructor
    constructor( private dialog: MatDialog, private http: HttpClient){
        super(http)
    }
    //#endregion Constructor

    //#region Public Methods

    public GetGenericContent(): Observable<GenericMemberResponsePortalResponseDto<GenericContentDto>>{
        return this.Get(`/Content`) as Observable<GenericMemberResponsePortalResponseDto<GenericContentDto>> ;
    }

    public OpenContactUs(): void{
        this.openDialog(FooterContactUsComponent);
    }

    public OpenFaq(): void{
        this.openDialog(FooterFaqComponent);
    }

    public OpenLanguageAccesibility(): void{
        this.openDialog(FooterLanguageAccesibilityComponent);
    }

    public OpenPrivacyPolicy(): void{
        this.openDialog(FooterPrivacyPolicyComponent);
    }

    public OpenWhoWeAre(): void{
        this.openDialog(FooterWhoWeAreComponent);
    }
    //#endregion Public Methods

    //#region Private Methods
    private openDialog(component:any): void{
        this.dialog.open(component);
    }
    //#endregion Private Methods
}
